// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface AlarmIconSignature {
  Element: SVGSVGElement;
}

export const AlarmIcon: TOC<AlarmIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M11 2H13V4.08329C15.8345 4.56058 18 7.03164 18 10V12.838C18 14.298 18.931 15.589 20.316 16.052L21 16.279V19H3V16.279L3.684 16.052C5.069 15.589 6 14.298 6 12.838V10C6 7.03164 8.16548 4.56058 11 4.08329V2ZM12 22C10.524 22 9.248 21.19 8.555 20H15.445C14.752 21.19 13.476 22 12 22ZM17.966 17H6.035C7.255 15.998 8 14.486 8 12.838V10C8 7.794 9.794 6 12 6C14.206 6 16 7.794 16 10V12.838C16 14.486 16.745 15.998 17.966 17Z"/>
</svg>
</template>;